export default __webpack_public_path__ + "static/media/icon_campaign_step.af8b4b13.svg";